//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { setEcommmerceType } from '@apis/catalog-validation/productCatalogValidation';
import { CATALOG_INGESTION_TYPES, CATALOG_SELECTION_MODAL_ACTIONS } from '@catalog-ingestion/constants/catalogSelectionConstants';
import { ICuralateStore } from '@models/AppState';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';

const changeCatalogType = (catalogType: CATALOG_INGESTION_TYPES) => {
  return createAction({
    type: CATALOG_SELECTION_MODAL_ACTIONS.CHANGE_CATALOG_TYPE,
    catalogType,
  });
};

const openCatalogSelectionModal = () => {
  return createAction({
    type: CATALOG_SELECTION_MODAL_ACTIONS.OPEN_MODAL,
  });
};

const closeCatalogSelectionModal = () => {
  return createAction({
    type: CATALOG_SELECTION_MODAL_ACTIONS.CLOSE_MODAL,
  });
};

const setSelectedEcommerceType = () => {
  return createAction({
    type: CATALOG_SELECTION_MODAL_ACTIONS.SET_SELECTED_ECOMMERCE_TYPE,
  });
};

const receiveSelectedEcommerceType = () => {
  return createAction({
    type: CATALOG_SELECTION_MODAL_ACTIONS.RECEIVE_SELECTED_ECOMMERCE_TYPE,
  });
};

export type CatalogSelectionModalAction = ReturnType<
  typeof changeCatalogType
  | typeof openCatalogSelectionModal
  | typeof closeCatalogSelectionModal
  | typeof setSelectedEcommerceType
  | typeof receiveSelectedEcommerceType
>;

export const CatalogSelectionModalActions = {
  changeCatalogType,
  openCatalogSelectionModal,
  closeCatalogSelectionModal,
  receiveSelectedEcommerceType,

  setSelectedEcommerceType: () => async (
    dispatch: ReduxDispatch,
    getState: () => ICuralateStore,
  ) => {
    const selectedCatalogType = getState().catalogIngestionReducers.catalogSelection.selectedCatalogType;

    dispatch(setSelectedEcommerceType());
    if (selectedCatalogType === CATALOG_INGESTION_TYPES.OTHER) {
      await setEcommmerceType();
    } else {
      await setEcommmerceType(selectedCatalogType);
      window.location.href = '/integration-settings/ecommerce-setup';
    }
    dispatch(receiveSelectedEcommerceType());
  },
};
